export * from "ce/constants/ModuleConstants";
import type {
  Module as CE_Module,
  ModuleInputSection as CE_ModuleInputSection,
  ModuleInput as CE_ModuleInput,
  ModuleMetadata as CE_ModuleMetadata,
} from "ce/constants/ModuleConstants";
import type { ControlData } from "components/formControls/BaseControl";
import type { Action } from "entities/Action";
import type { JSCollection } from "entities/JSCollection";

export interface DynamicPath {
  key: string;
  value?: string;
}

export enum MODULE_TYPE {
  QUERY = "QUERY_MODULE",
  JS = "JS_MODULE",
  UI = "UI_MODULE",
}
export enum MODULE_PREFIX {
  QUERY = "Query",
  JS = "JS",
  UI = "UI",
}
export interface PluginSettings {
  id: number;
  sectionName: string;
  children: ControlData[];
}

export interface ModuleInput extends CE_ModuleInput {
  label: string;
  defaultValue: string;
  controlType: string;
}

export interface ModuleOutput {
  id: string;
  propertyName: string;
  label: string;
  value: string;
  controlType: string;
}
export interface ModuleOutputSection {
  id: string;
  sectionName: string;
  children: ModuleOutput[];
}
export interface PluginSettings {
  id: number;
  sectionName: string;
  children: ControlData[];
}

export interface ModuleInputSection extends CE_ModuleInputSection {
  sectionName: string;
  children: ModuleInput[];
}

export interface ModuleOnInputChange {
  id: string;
  value: string;
  controlType: string;
  propertyName?: string;
  label?: string;
  inputId: string;
}

export interface ModuleOnInputChangeSection {
  id: string;
  sectionName: string;
  children: ModuleOnInputChange[];
}

export interface BaseModule<TLayout = unknown> extends CE_Module {
  inputsForm: ModuleInputSection[];
  outputsForm: ModuleOutputSection[];
  settingsForm: PluginSettings[];
  type: MODULE_TYPE;
  userPermissions: string[];
  originModuleId?: string;
  version: string;
  actionId: string;
  moduleUUID: string;
  layouts?: TLayout[];
  dynamicBindingPathList?: DynamicPath[];
  dynamicTriggerPathList?: DynamicPath[];
  dynamicPropertyPathList?: DynamicPath[];
  onInputChange?: Record<string, string>;
}

export interface ModuleMetadata extends CE_ModuleMetadata {
  publicEntity: Action | JSCollection;
}

export type Module<TLayout = unknown> = BaseModule<TLayout> &
  Pick<ModuleMetadata, "datasourceId" | "pluginId" | "pluginType">;

export enum MODULE_ENTITY_TYPE {
  ACTION = "ACTION",
  JS_OBJECT = "JS_OBJECT",
}

export const ENTITY_EXPLORER_RENDER_ORDER = [
  MODULE_TYPE.UI,
  MODULE_TYPE.JS,
  MODULE_TYPE.QUERY,
];

export enum MODULE_EDITOR_TYPE {
  QUERY = "QUERY",
  API = "API",
}

export const MODULE_ON_INPUT_CHANGE_CONTROL_KEY = "__$KEY$__";
